import {NgModule} from '@angular/core';
import {TASK_SERVICE} from '../../specification/injection-tokens';
import {NetcomTaskService} from './services/task.service';
import {
  Configuration,
  ConfigurationParameters,
  Twict4FiberWebRestSdkApiModule
} from 'twict4fiber-api-web-rest-angular-17';
import {defaultBasePath} from '../../constants';

@NgModule({
  imports: [
    Twict4FiberWebRestSdkApiModule.forRoot((): Configuration => {
      const configurationParameters: ConfigurationParameters = {
        basePath: defaultBasePath,
      };

      return new Configuration(configurationParameters);
    }),
  ],
  providers: [
    {provide: TASK_SERVICE, useClass: NetcomTaskService}
  ]
})
export class NetcomApiAdapterModule {
}
